import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useContext } from "react";
import BorseContext from "../../context/borse";
import UserContext from "../../context/user";

const useBorseDocumentsConfirmMutation = (closeModal) => {
  const { userProfile, callApi } = useContext(UserContext);
  const { setCurrentRequest } = useContext(BorseContext);
  const queryClient = useQueryClient();

  return useMutation(
    ({ request }) =>
      callApi(`/scholarship/request/${request?.id}/confirmAdditionalFiles`, {
        method: "PUT",
      }),
    {
      onSuccess: () => {
        if (closeModal) {
          closeModal();
          setCurrentRequest();
          queryClient.invalidateQueries(["requests", JSON.stringify(userProfile)]);
        }
      },
    }
  );
};

export default useBorseDocumentsConfirmMutation;
